import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const TransactionDocumentPagesProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `TransactionDocumentSetup/GetDocumentPages/${props.documentId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `TransactionDocumentSetup/CreateDocumentPage/`, method: 'POST', payload: props.data, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute(
            {
                scope: 'update',
                url: `TransactionDocumentSetup/EditDocumentPage/${props.id}/${props.name}`,
                method: 'POST',
                payload: {
                    id: props.id,
                    name: props.name
                },
                secure: true
            }
        );
    }, [execute]);

    const setPageStatus = useCallback(async (props) => {
        await execute({ scope: 'updateStatus', url: `TransactionDocumentSetup/SetDocumentPageStatus/${props.id}`, payload: props.id, method: 'POST', secure: true });
    }, [execute]);

    const value = { selectRecord, newRecord, updateRecord, setPageStatus, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useTransactionDocumentPagesStore = () => React.useContext(Context);
